/* eslint-disable import/prefer-default-export */

import { DEVTOOLBAR_ALLOWED_ENVIRONMENTS } from '@components/DevToolbar/const';
import { ENVIRONMENT } from '@const/index';
export const isDevToolbarAllowed = (): boolean => {
  if (DEVTOOLBAR_ALLOWED_ENVIRONMENTS.includes(ENVIRONMENT)) {
    return true;
  }
  return false;
};